import * as tslib_1 from "tslib";
import { EventBase } from "@awayjs/core";
var RTTEvent = (function (_super) {
    tslib_1.__extends(RTTEvent, _super);
    function RTTEvent(type, rttManager) {
        var _this = _super.call(this, type) || this;
        _this._rttManager = rttManager;
        return _this;
    }
    Object.defineProperty(RTTEvent.prototype, "rttManager", {
        /**
         *
         */
        get: function () {
            return this._rttManager;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     */
    RTTEvent.prototype.clone = function () {
        return new RTTEvent(this.type, this._rttManager);
    };
    return RTTEvent;
}(EventBase));
export { RTTEvent };
/**
 *
 */
RTTEvent.RESIZE = "rttManagerResize";



// WEBPACK FOOTER //
// ../dist/lib/events/RTTEvent.js